var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "bg-white",
      style: _vm.getStyle,
      attrs: { id: "skillRatingsInProgressCard" },
    },
    [
      _c(
        "vx-card",
        [
          _c("h2", { staticClass: "mb-2" }, [
            _vm._v(
              "\n            " +
                _vm._s(_vm.skillRatingNames.plural) +
                " en cours\n        "
            ),
          ]),
          _vm._v(" "),
          _c(
            "vs-row",
            [
              _c(
                "vs-col",
                {
                  attrs: {
                    "vs-type": "flex",
                    "vs-justify": "center",
                    "vs-align": "center",
                    "vs-w": "12",
                  },
                },
                [
                  _c(
                    "vs-table",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        "no-data-text": "Aucune donnée à afficher",
                        data: _vm.ratings,
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function ({ data }) {
                            return _vm._l(_vm.ratings, function (item, i) {
                              return _c(
                                "vs-tr",
                                { key: i, attrs: { data: item } },
                                [
                                  _c(
                                    "vs-td",
                                    [
                                      _vm.get(item, ":employee.photoUrl")
                                        ? _c("vs-avatar", {
                                            attrs: {
                                              size: "30px",
                                              src: _vm.get(
                                                item,
                                                ":employee.photoUrl"
                                              ),
                                            },
                                          })
                                        : _c("vs-avatar", {
                                            attrs: {
                                              size: "30px",
                                              color: _vm.generateColor(
                                                _vm.get(item, ":employee.name")
                                              ),
                                            },
                                          }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("vs-td", [
                                    _c(
                                      "a",
                                      {
                                        staticStyle: {
                                          color: "rgb(98, 98, 98)",
                                        },
                                        attrs: {
                                          href:
                                            "/rh/gestion/personnes/" +
                                            _vm.get(item, ":employee.id") +
                                            "/bilans",
                                        },
                                      },
                                      [
                                        _c("p", [
                                          _c("b", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.get(
                                                  item,
                                                  ":employee.last_name"
                                                )
                                              )
                                            ),
                                          ]),
                                        ]),
                                      ]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("vs-td", [
                                    _c(
                                      "a",
                                      {
                                        staticStyle: {
                                          color: "rgb(98, 98, 98)",
                                        },
                                        attrs: {
                                          href:
                                            "/rh/gestion/personnes/" +
                                            _vm.get(item, ":employee.id") +
                                            "/bilans",
                                        },
                                      },
                                      [
                                        _c("p", [
                                          _c("b", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.get(
                                                  item,
                                                  ":employee.first_name"
                                                )
                                              )
                                            ),
                                          ]),
                                        ]),
                                      ]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("vs-td", [
                                    _c(
                                      "a",
                                      {
                                        staticStyle: {
                                          color: "rgb(98, 98, 98)",
                                        },
                                        attrs: {
                                          href:
                                            "/rh/gestion/personnes/" +
                                            _vm.get(item, ":employee.id") +
                                            "/bilans",
                                        },
                                      },
                                      [
                                        _c("p", [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("subStringDate")(
                                                _vm.get(item, ":created_at")
                                              )
                                            )
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("vs-td", [
                                    _c(
                                      "a",
                                      {
                                        staticStyle: {
                                          color: "rgb(98, 98, 98)",
                                        },
                                        attrs: {
                                          href:
                                            "/rh/gestion/personnes/" +
                                            _vm.get(item, ":employee.id") +
                                            "/bilans",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                                    " +
                                            _vm._s(
                                              _vm
                                                .get(item, ":employee.services")
                                                .map((s) => s.title)
                                                .join(", ")
                                            ) +
                                            "\n                                "
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("vs-td", [
                                    _c(
                                      "a",
                                      {
                                        staticStyle: {
                                          color: "rgb(98, 98, 98)",
                                        },
                                        attrs: {
                                          href:
                                            "/rh/gestion/personnes/" +
                                            _vm.get(item, ":employee.id") +
                                            "/bilans",
                                        },
                                      },
                                      [
                                        _c("p", [
                                          _vm._v(
                                            _vm._s(
                                              _vm
                                                .get(item, ":employee.services")
                                                .map(
                                                  (s) => s.establishment.name
                                                )
                                                .join(", ")
                                            )
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "vs-td",
                                    { staticClass: "action" },
                                    [
                                      _vm.canMulti(
                                        "update",
                                        "skill_reviews",
                                        item.employee.services.length > 0
                                          ? item.employee.services.map(
                                              (s) => s.id
                                            )
                                          : null
                                      )
                                        ? _c("vs-button", {
                                            attrs: {
                                              id: "createRatingEmployee_" + i,
                                              href: `/rh/gestion/personnes/${item.employee.id}/bilans/poursuivre/${item.id}?skill-review=true`,
                                              "v-tooltip":
                                                "Poursuivre le " +
                                                _vm.projectNames.singular,
                                              color: "primary",
                                              type: "border",
                                              "icon-pack": "feather",
                                              icon: "icon-edit",
                                            },
                                          })
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            })
                          },
                        },
                      ]),
                    },
                    [
                      _c(
                        "template",
                        { slot: "thead" },
                        [
                          _c("vs-th"),
                          _vm._v(" "),
                          _c("vs-th", [_vm._v("Nom")]),
                          _vm._v(" "),
                          _c("vs-th", [_vm._v("Prénom")]),
                          _vm._v(" "),
                          _c("vs-th", [_vm._v("Date création")]),
                          _vm._v(" "),
                          _c("vs-th", [_vm._v("Service")]),
                          _vm._v(" "),
                          _c("vs-th", [_vm._v("Etablissement")]),
                          _vm._v(" "),
                          _c("vs-th", [_vm._v("Continuer")]),
                        ],
                        1
                      ),
                    ],
                    2
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "vs-row",
            [
              _c("vs-col", { staticClass: "text-right mt-2" }, [
                _c(
                  "a",
                  {
                    attrs: {
                      href: "/rh/gestion/bilans#skillrating-in-progress",
                    },
                  },
                  [_vm._v("Voir plus...")]
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }